import { RefObject, useEffect } from 'react';

import './comparablesToast.scss';
import {
  COMPARABLES_TOAST_RIGHT_CSS_VAR,
  COMPARABLES_TOAST_TOP_CSS_VAR,
} from './constants.ts';

const TOP_GUTTER_PX = 8;
const RIGHT_GUTTER_PX = 12;

const setAnchorCssVars = (top: number, right: number) => {
  document.documentElement.style.setProperty(COMPARABLES_TOAST_TOP_CSS_VAR, `${top}px`);
  document.documentElement.style.setProperty(COMPARABLES_TOAST_RIGHT_CSS_VAR, `${right}px`);
};

const clearAnchorCssVars = () => {
  document.documentElement.style.removeProperty(COMPARABLES_TOAST_TOP_CSS_VAR);
  document.documentElement.style.removeProperty(COMPARABLES_TOAST_RIGHT_CSS_VAR);
};

export const useComparablesToastAnchor = (
  containerRef: RefObject<HTMLElement | null>,
  moduleId: string,
) => {
  useEffect(() => {
    const getAnchor = () =>
      containerRef.current?.closest<HTMLElement>(`#${moduleId}-module`) ??
      containerRef.current;

    const updateAnchor = () => {
      const anchor = getAnchor();
      if (!anchor) {
        clearAnchorCssVars();
        return;
      }

      const rect = anchor.getBoundingClientRect();
      setAnchorCssVars(rect.top + TOP_GUTTER_PX, window.innerWidth - rect.right + RIGHT_GUTTER_PX);
    };

    updateAnchor();

    const anchor = getAnchor();
    const resizeObserver = anchor ? new ResizeObserver(updateAnchor) : undefined;
    if (anchor) {
      resizeObserver?.observe(anchor);
    }
    window.addEventListener('resize', updateAnchor);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateAnchor);
      clearAnchorCssVars();
    };
  }, [containerRef, moduleId]);
};
